module.exports = __webpack_public_path__ + "media/Video 93.123bd617.mp4";